<template>
    <div>
        <h4 class="pb-1">{{metric.displayName}}</h4>
        <table>
            <tr>
                <td class="pr-5">CUSIP</td>
                <td>{{ value(metric.name) }}{{ unitsWithSpace(metric) }}</td>
            </tr>
            <tr v-if="hasCohortData(metric)">
                <td class="pr-5">Cohort</td>
                <td>{{ value(cohortName(metric)) }}{{ unitsWithSpace(metric)}}</td>
            </tr>
        </table>
        <br>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { cohortName, hasData } from '@/utils/climate'

export default {
    props: [ 'metric' ],
    computed: {
        ...mapState({
            summaryData: state => state.summaryData
        }),
        },
    methods: {
        cohortName(metric) {
            return cohortName(metric.name)
        },
        isPercent(metric) {
            return metric.units === '%'
        },
        unitsWithSpace(metric) {
            return this.isPercent(metric) ? metric.units : ` ${metric.units}`
        },
        hasData(metric) {
            return hasData(metric, this.summaryData)
        },
        cohortData(metric) {
            return this.summaryData[this.cohortName(metric)]
        },
        hasCohortData(metric) {
            return this.cohortData(metric) !== undefined && this.cohortData(metric) !== null
        },
        value(metricName) {
            let fullValue = this.summaryData[metricName]
            return metricName === "pcaf_attribution_factor" ? fullValue.toFixed(2) : fullValue.toFixed(1)
        }
    }
}
</script>
